<template>
  <div class="booking-rodo__agreement" :class="getValidationClasses()">
    <div class="booking-rodo__agreement--item" :class="required ? 'required':''">
      <CheckBox class="checkbox" @input="input"
        :name="vvName" :key="vvKey" :enabled="item.enabled"
        data-vv-validate-on="change" data-vv-as="imię"
        v-model="selected" :validateAs="validateAs" v-validate="{ rules: rules }" />
      <CheckBoxLabel class="label" v-model="selected" :enabled="item.enabled" @input="input"
        :text="item.name" :html="item.html" tabindex="0" />
    </div>

    <div v-if="errors.has(validationField(validateAs))" class="v-field-error">{{ errors.first(validationField(validateAs)) }}</div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import Vue from 'vue'
import Component from 'vue-class-component'

import CheckBox from '@/components/CheckBox.vue'
import CheckBoxLabel from '@/components/CheckBoxLabel.vue'
import CustomControlValidationMixin from '@/components/CustomControlValidationMixin'

@Component({
  mixins: [
    CustomControlValidationMixin,
  ],
  components: {
    CheckBox,
    CheckBoxLabel,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    vvKey: {
      type: String,
      required: true,
    },
    vvName: {
      type: String,
      required: true,
    },
    validateAs: {
      type: String,
      required: true,
    },
    rules: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    value (selected) {
      this.selected = selected
    },
  },
})
export default class RodoFormAgreement extends Vue {
  selected = cloneDeep(this.value)

  input (value) {
    this.manualValidateChangedField(value)
    this.$emit('input', value)
  }

  manualValidateChangedField (value) {
    this.$validator.validate(this.validateAs, value)
    this.$validator.fields.find({ name: this.validateAs }).setFlags({ 'changed': true })
  }
}
</script>

<style lang="scss" scoped>
.booking-rodo__agreement {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  &--item {
    display: flex;
  }

  &.field-invalid .checkbox-label {
    color: #E71F6C;
  }

  .v-field-error {
    margin-top: 5px;
    padding: 10px;
    background-color: #E71F6C;
    color: #fff;
    font-size: 11px;
    text-align: left;
    font-weight: bold;
    font-family: 'Gotham Book';
  }
}

.checkbox {
  margin-right: 5px;
  background: transparent;
  border: 2px solid #005CA9;
  color: transparent;

  &::before {
    top: -6px;
    left: 2px;
  }

  &--checked {
    color: #005CA9;
  }
}

.checkbox-label {
  flex: 1;
  line-height: 15px;
  font-family: 'Gotham Book';
  font-size: 10px;
  color: #535353;
  cursor: pointer;
  outline: none;

  b {
    color: #535353;
    text-transform: uppercase;
    font-size: 12px;
  }

  a {
    text-transform: uppercase;
    font-family: 'Gotham';
    font-weight: normal;
    font-size: 12px;
    text-decoration: underline;
    text-decoration-color: rgba(0,92,169,.5);
  }
}
</style>

<style lang="scss">
.booking-rodo__agreement.field-invalid .checkbox {
  border-color: #E71F6C;
}
.booking-rodo__agreement--item.required .label span:after {
  content: '*';
  color: #E71F6C;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/booking/RodoFormAgreement.vue